import type { Id } from '../../../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type GetProfileRequestPayload = {
  humanProxyId: Id
}

export const GetProfileRequestPayloadSchema: CborSchema<GetProfileRequestPayload> =
  defineCborSchema<GetProfileRequestPayload>({
    humanProxyId: CborField({ key: 0 }),
  })
